<template>
  <div>
    <el-form ref="form" :rules="rules" :model="form" label-width="100px">
      <el-form-item label="First Name" prop="FirstName">
        <el-input v-model="form.FirstName"></el-input>
      </el-form-item>
      <el-form-item label="Last Name" prop="LastName">
        <el-input v-model="form.LastName"></el-input>
      </el-form-item>
      <el-form-item
        v-for="(phone, index) in form.PhoneNumbers"
        :label="'Phone ' + (index+1 )"
        :key="phone.key"
        :prop="'PhoneNumbers.' + index + '.Number'"
      >
        <el-input v-model="phone.Number" type="tel"></el-input>
        <el-button v-if="index > 0" type="text" icon="el-icon-minus">Phone</el-button>
      </el-form-item>
      <!-- <el-form-item size="mini">
        <el-button icon="el-icon-plus" type="text">Phone</el-button>
      </el-form-item>-->
      <el-form-item
        v-for="(email, index) in form.EmailAddresses"
        :label="'Email ' + (index+1 )"
        :key="email.key"
        :prop="'EmailAddresses.' + index + '.Email'"
      >
        <el-input type="email" v-model="email.Email"></el-input>
        <el-button v-if="index > 0" type="text" icon="el-icon-minus">Email</el-button>
      </el-form-item>
      <!-- <el-form-item size="mini">
        <el-button icon="el-icon-plus" type="text" size="mini">Email</el-button>
      </el-form-item>-->
      <el-form-item
        v-for="(address, index) in form.Addresses"
        :label="'Address ' + (index+1 )"
        :key="address.key"
        :prop="'Addresses.' + index + '.Address'"
      >
        <el-input v-model="address.Address"></el-input>
        <el-button v-if="index > 0" type="text" icon="el-icon-minus">Address</el-button>
      </el-form-item>
      <!-- <el-form-item size="mini">
        <el-button icon="el-icon-plus" type="text" size="mini">Address</el-button>
      </el-form-item>-->
      <el-form-item label="Notes">
        <el-input v-model="form.Notes[0].Note" type="textarea"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button @click="$router.push({name: 'Contacts'})">Cancel</el-button>
        <el-button v-loading="isSubmitting" type="primary" @click="onSubmit('form')">Create</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  props: {
    id: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      isSubmitting: false,
      form: {
        FirstName: '',
        LastName: '',
        PhoneNumbers: [
          {
            Editable: true,
            Primary: true,
            Type: 'PO'
          }
        ],
        EmailAddresses: [
          {
            Editable: true,
            Email: '',
            Primary: true,
            Type: 'PO'
          }
        ],
        Addresses: [
          {
            Address: '',
            Editable: true,
            Primary: true
          }
        ],
        Notes: [
          {
            Note: ''
          }
        ]
      },
      rules: {
        FirstName: [
          {
            required: true,
            message: 'Please input first name',
            trigger: 'blur'
          }
        ],
        LastName: [
          {
            required: true,
            message: 'Please input last name',
            trigger: 'blur'
          }
        ]
      }
    }
  },
  computed: {
    ...mapGetters(['contacts'])
  },
  methods: {
    onSubmit(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.isSubmitting = true
          this.$store.dispatch('createContact', this.form)
        } else {
          this.$alert('Please finish adding contact details.', 'Oh no!', {
            confirmButtonText: 'OK'
          })
          return false
        }
      })
    },
    findContact(id) {
      if (!id) return
      const contact = this.contacts.filter(c => c.Id === id)
      this.form = contact
    }
  },
  watch: {
    id: {
      handler: 'findContact',
      immediate: true
    }
  }
}
</script>

<style>
</style>
